module.exports = __webpack_public_path__ + "b2b02ee704d2070eeb3d8ef82f35411d.svg";